var app = angular.module("leonardo");

var CategoryList = function($scope, $state, $controller, ngDialog, CategoryRestService, SubCategoryRestService,
                            FilterService) {

  $scope.categories = [];

  $scope.service = $state.current.subcategory ? SubCategoryRestService : CategoryRestService;

  $scope.getEntitiesPromise = function(options) {
    options.name__icontains = FilterService.getFilter('category_name');
    options.sector = FilterService.getFilter('sector');
    return $scope.service.getlist(options);
  };

  $scope.editCategory = function(category){
    if ($state.current.subcategory) {
      $state.go('categories.subcategory-edit', {pk: category.id});
    }
    else {
      $state.go('categories.edit', {pk: category.id});
    }
  };

  $scope.showDeleteCategory = function(category){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: category,
        type: $state.current.subcategory ? 'subcategory' : 'category'
      }
    }).then(function(data){
      $scope.service.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);

};

app.controller('CategoryList', ['$scope', '$state', '$controller', 'ngDialog', 'CategoryRestService',
  'SubCategoryRestService', 'FilterService', CategoryList]);
